import { getSessionStoreKey as e } from "@systemeio/util";
import { useSessionStorage as l, useLocalStorage as t } from "usehooks-ts";
const f = () => {
  const [o, s] = l(e("ai-chat-open"), !1), [n, r] = t(e("ai-chat-chat-open"), !0), [a, c] = t(
    e("ai-chat-history-open"),
    !1
  ), [i, p] = t(
    e("ai-chat-fullscreen"),
    !1
  );
  return {
    open: o,
    setOpen: s,
    chatOpen: n,
    setChatOpen: r,
    historyOpen: a,
    setHistoryOpen: c,
    fullScreen: i,
    setFullScreen: p
  };
};
export {
  f as useWidgetControls
};
